import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { ContentWidthEnum } from 'common/types/styleTypes'
import { generateHtmlAttrId } from 'src/shared/entities/utils/generate-base-entity'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { v4 as uuid } from 'uuid'

export interface CreateWebsiteHeaderProps {
  id?: string
  childIds?: string[]
  parentId: string
}

export const createWebsiteHeader = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  id = uuid(),
  childIds?: string[],
): WebsiteHeaderInterface => {
  const entity: WebsiteHeaderInterface = {
    id,
    parentId,
    type: EntityTypeEnum.WebsiteHeader,
    contentWidth: ContentWidthEnum.l,
    childIds: childIds || [],
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.WebsiteHeader),
  }

  return entity
}
